import { OResponsiveModal, OButton } from '@src/shared';
import styles from './deleteModal.module.scss';
import { useDeleteModal } from './useDeleteModal';

interface DeleteModalProps {
  openConfirmModal: boolean;
  onClose: () => void;
  meetingId: string;
}

const DeleteModal = ({ openConfirmModal, onClose, meetingId }: DeleteModalProps) => {
  const { handleDeleteWebinar, loading } = useDeleteModal({ onClose, meetingId });

  return (
    <OResponsiveModal
      modalClasses={{
        container: styles.deleteModalContainer,
        title: styles.title,
        modal: styles.modal,
      }}
      isOpen={openConfirmModal}
      onClose={onClose}
      title="Delete this webinar?"
    >
      <div className={styles.bottomSheetBody}>
        <p className={styles.description}>
          This action will permanently remove the webinar and redirect you to the home screen. It cannot be reversed.
        </p>
        <div className={styles.buttonContainerBottomSheet}>
          <OButton
            text="Delete"
            size="x-small"
            classes={{
              container: styles.deleteButton,
            }}
            onClick={handleDeleteWebinar}
            variant="danger"
            loading={loading}
          />
          <OButton
            text="Cancel"
            size="x-small"
            classes={{
              container: styles.cancelButton,
            }}
            onClick={onClose}
            variant="cancel"
            outlined
          />
        </div>
      </div>
    </OResponsiveModal>
  );
};

export default DeleteModal;
